import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import InputImage from '../../../../component/Input/InputImage';
import { getToken } from '../../../../helpers/Jwt';
import { confirmModal } from '../../../../helpers/PromptUtils';
import Navbar from '../component/Navbar';
import InputFile from '../../../../component/Input/InputFile';

const EntryReservation = () => {

    const url = window.location.origin;
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;

    const [optionUnitKerja, setOptionUnitKerja] = useState([]);
    const [optionService, setOptionService] = useState([]);

    const [uploadedFile, setUploadedFile] = useState(null);


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_SUBPROJECT = "api/kejati/reservation/subproject";
    const PATH_SERVICE = "api/kejati/reservation/service";

    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_SUBPROJECT}`,).then((data) => {
            setOptionUnitKerja(data);
        });

        fetchData(`${BASE_URL}${PATH_SERVICE}`,).then((data) => {
            setOptionService(data);
        });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`);
                setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${response.data.logo}`)
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [domain]);

    const initialValues = {

    };

    const validationSchema = Yup.object({
    });

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const formData = new FormData();

            // Append data Formik
            for (const key in values) {
                formData.append(key, values[key]);
            }

            // Append file jika ada
            if (uploadedFile) {
                formData.append('file', uploadedFile); // key 'file' sesuai dengan backend
            }

            const response = await axios.post(`${BASE_URL}${PATH_SERVICE}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            const confirmed = confirmModal(response.data);
            if (confirmed) {
                window.location.reload();
            }
        } catch (error) {
            alert(error?.response?.data || "Terjadi kesalahan saat mengirim data.");
            console.error('Error submitting form:', error);
        } finally {
            setSubmitting(false);
        }
    };


    // const onSubmit = async (values, { setSubmitting }) => {
    //     try {
    //         const response = await axios.post(`${BASE_URL}${PATH_SERVICE}`, values, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${getToken()}`
    //             }
    //         });

    //         const confirmed = confirmModal(response.data);
    //         if (confirmed) {
    //             window.location.reload();
    //         }
    //     } catch (error) {
    //         alert(error.response.data);
    //         // console.error('Error submitting form:', error.response.data);
    //     } finally {
    //         setSubmitting(false);
    //     }
    // };

    const overlayStyle = {
        position: 'absolute',           // Absolutely position the overlay on top of the background
        top: '150px',
        left: 0,
        right: 0,
        bottom: '150px',
        backgroundImage: `url(${appLogo})`,  // Dynamically use the appLogo as the background image
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
        pointerEvents: 'none',
    };

    return (
        <div >
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
            <div className="mx-auto max-w-md w-full">

                <div style={overlayStyle}></div>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, handleChange, setFieldValue, isSubmitting }) => (
                        <Form>
                            <div className="container m-auto py-32">
                                <div className="px-3 py-2">
                                    <label htmlFor="unit_kerja" className="mb-1 text-sm font-semibold">Unit Kerja</label>
                                    <Field
                                        as="select"
                                        name="unit_kerja"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                        onChange={(e) => setFieldValue(`unit_kerja`, e.target.value)}
                                    >
                                        <option value="">Pilih Unit Kerja</option>
                                        {optionUnitKerja.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </Field>
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="service" className="mb-1 text-sm font-semibold">Jenis Layanan</label>
                                    <Field
                                        as="select"
                                        name="service"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                        onChange={(e) => setFieldValue(`service`, e.target.value)}
                                    >
                                        <option value="">Pilih Jenis Layanan</option>
                                        {optionService.map((option) => (
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </Field>
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="name" className="mb-1 text-sm font-semibold">Nama</label>
                                    <Field
                                        name="name"
                                        placeholder="Nama"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="name" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="nik" className="mb-1 text-sm font-semibold">NIK</label>
                                    <Field
                                        name="nik"
                                        placeholder="NIK"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="nik" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="whatsapp" className="mb-1 text-sm font-semibold">No. Whatsapp</label>
                                    <Field
                                        name="whatsapp"
                                        placeholder="No. Whatsapp"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="whatsapp" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl Kedatangan</label>
                                    <Field
                                        type='date'
                                        name="date"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="time" className="mb-1 text-sm font-semibold">Jam</label>
                                    <Field
                                        type='time'
                                        name="time"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="time" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="description" className="mb-1 text-sm font-semibold">Keterangan</label>
                                    <Field
                                        as="textarea"
                                        name="description"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="description" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2">
                                    <label htmlFor="traffic_ticket" className="mb-1 text-sm font-semibold">No. Berkas</label>
                                    <Field
                                        name="traffic_ticket"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="traffic_ticket" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <InputFile
                                    attr={{
                                        name: 'file',
                                        placeholder: 'Unggah Berkas (Optional)',
                                        accept: '.pdf,.doc,.docx,.zip,.rar', // optional
                                    }}
                                    handleUploadedFile={(file) => {
                                        setUploadedFile(file);
                                    }}
                                />

                                <InputImage attr={{
                                    "name": "image_traffic_ticket",
                                    "placeholder": "Foto Berkas (Optional)"
                                }} handleCroppedFoto={(value) => {
                                    setFieldValue("image_traffic_ticket", value);
                                }} />

                                {/* <InputImage attr={{
                                    "name": "image_proof_payment",
                                    "placeholder": "Foto Berkas"
                                }} handleCroppedFoto={(value) => {
                                    setFieldValue("image_proof_payment", value);
                                }} /> */}

                                <div className="px-3 py-2 flex items-center justify-end mt-5">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                            }`}
                                    >
                                        {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default EntryReservation;
